import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-misala',
  templateUrl: './misala.component.html',
  styleUrls: ['./misala.component.css']
})
export class MisalaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
